export default "/assets/images/sock.6eee7f25e0978eac.webp";